import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SummaryOverlayComponent } from './summary-overlay.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import {
  CommunityListComponentModule,
  EducationCourseListModule,
  EventsListModule,
  GCAPListModule,
} from '@lists/_index';

@NgModule({
  imports: [
    CommonModule,
    EventsListModule,
    CommunityListComponentModule,
    EducationCourseListModule,
    MatButtonModule,
    MatDialogModule,
    GCAPListModule,
    RouterModule,
    SummaryOverlayComponent,
  ],
  exports: [SummaryOverlayComponent],
})
export class SummaryOverlayModule {}
